import { object, array } from 'yup';

export default object().shape({
  client: object().nullable().required(),
  contact: object().nullable().required(),
  billingAddress: object().nullable().required(),
  items: array().required().min(1),
  adjustments: array(),
});
